import { h } from '@stencil/core';
import cn from 'classnames';
import { ECommercialStatus, getQdsIconLibrary } from '@pes-ui/utils';
import { isMobile } from '../../../globals/utils';
var RangeType;
(function (RangeType) {
  RangeType["SOFTWARE_FREE"] = "software_free";
  RangeType["SOFTWARE_PAID"] = "software_paid";
})(RangeType || (RangeType = {}));
const SoftwareRangeTypes = [RangeType.SOFTWARE_FREE, RangeType.SOFTWARE_PAID];
export class RangeInfo {
  constructor() {
    this.image = undefined;
    this.name = undefined;
    this.description = undefined;
    this.masterRangeName = undefined;
    this.longDescription = undefined;
    this.rangePartofLabel = undefined;
    this.commercialStatus = undefined;
    this.brandLogo = undefined;
    this.rangeCtas = [];
    this.moreOptionsLabel = undefined;
    this.getSelectorConfig = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.learnMoreLabel = undefined;
    this.isExternalConsumer = undefined;
    this.rangeType = undefined;
    this.isVisible = false;
    this.isMobile = isMobile();
    this.rangeSubtitle = undefined;
  }
  getWrapped(text) {
    return `<!--LONGDESC_BEGIN-->${text}<!--LONGDESC_END-->`;
  }
  changeVisibility() {
    this.isVisible = !this.isVisible;
  }
  learnMoreHandler() {
    document.dispatchEvent(new CustomEvent('activeOverview'));
  }
  componentDidLoad() {
    if (!this.description)
      return;
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.description, 'text/html');
    const plainText = doc.body.textContent || '';
    this.rangeSubtitle = plainText;
  }
  render() {
    const isSoftwareRange = SoftwareRangeTypes.includes(this.rangeType);
    return (h("div", { class: "range-info" }, h("div", { class: cn('range-info__wrapper') }, h("div", { class: "range-info__info" }, h("qds-title", { class: "range-info__title", layer: "main", level: "section", tag: "h1", alignment: "start", variant: "web-main-section-hero", subtitle: this.rangeSubtitle, innerHTML: this.name || '-' }), h("div", { class: this.isVisible ? '' : 'blurred-text' }, ''), this.masterRangeName ? (h("qds-title", { class: this.isVisible
        ? 'range-info__description'
        : 'range-info__description hide-in-mobile ', layer: 'main', level: 'subsection', alignment: 'start', variant: 'web-main-subsection-card', innerHTML: this.rangePartofLabel
        && this.rangePartofLabel.replace('#MasterRangeName#', this.masterRangeName) })) : null, h("div", { class: this.isVisible
        ? 'range-info__description'
        : 'range-info__description hide-in-mobile ' }, h("div", { class: "longDescription", innerHTML: this.getWrapped(this.longDescription) }), ' ', this.learnMoreLabel && (h("qds-button", { size: "standard", importance: "subdued", onClick: () => this.learnMoreHandler(), text: this.learnMoreLabel, iconName: "arrow-down", iconLibrary: getQdsIconLibrary("arrow-down") }))), h("div", { class: this.isVisible ? 'status-block' : 'hide-in-mobile' }, !this.isMobile
      && this.commercialStatus
      && this.commercialStatus.status !== ECommercialStatus.COMMERCIALIZED && (h("pes-badge-wrapper", { class: "card__badge card__additional-info-item", size: "large", type: this.commercialStatus.status, label: this.commercialStatus.label, color: this.commercialStatus.color })), this.brandLogo && (h("div", { class: "status-block__brand-logo" }, h("img", { src: this.brandLogo.url, alt: this.brandLogo.alt, fetchpriority: "high" })))), h("pes-range-cta", { class: "range-info__cta-button-block", rangeCtas: this.rangeCtas, getSelectorConfig: this.getSelectorConfig, isExternalConsumer: this.isExternalConsumer, moreOptionsLabel: this.moreOptionsLabel })), this.image && (h("div", { class: cn('range-info__image', { 'hide-in-mobile': !this.isVisible, 'range-info_software__image': isSoftwareRange }) }, h("img", { src: this.image.url, alt: this.image.title, fetchpriority: "high" })))), h("div", { class: this.isVisible ? '' : 'blurred-text' }), h("qds-button", { size: "standard", importance: "subdued", class: "btn-readmore", action: this.isVisible ? 'dropdown-close' : 'dropdown', onClick: this.changeVisibility.bind(this), text: this.isVisible ? this.readLessLabel : this.readMoreLabel }), h("div", { class: "commercial-status-mobile" }, this.commercialStatus
      && this.commercialStatus.status !== ECommercialStatus.COMMERCIALIZED && (h("pes-badge-wrapper", { class: "card__badge card__additional-info-item", size: "large", type: this.commercialStatus.status, label: this.commercialStatus.label, color: this.commercialStatus.color })))));
  }
  static get is() { return "pes-range-info"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-info.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-info.css"]
    };
  }
  static get properties() {
    return {
      "image": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "image",
        "reflect": false
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "description",
        "reflect": false
      },
      "masterRangeName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "master-range-name",
        "reflect": false
      },
      "longDescription": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "long-description",
        "reflect": false
      },
      "rangePartofLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-partof-label",
        "reflect": false
      },
      "commercialStatus": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.CommercialStatus",
          "resolved": "{ color?: string; status?: CommercialStatusType; label?: string; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "brandLogo": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "brand-logo",
        "reflect": false
      },
      "rangeCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRangeCTAs",
          "resolved": "TRangeCTAItem[]",
          "references": {
            "TRangeCTAs": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[]"
      },
      "moreOptionsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "more-options-label",
        "reflect": false
      },
      "getSelectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "() => Promise<TSelectorConfigRequestResponse>",
          "resolved": "() => Promise<TSelectorConfigRequestResponse>",
          "references": {
            "Promise": {
              "location": "global"
            },
            "TSelectorConfigRequestResponse": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "learnMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "learn-more-label",
        "reflect": false
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "rangeType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-type",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "isVisible": {},
      "isMobile": {},
      "rangeSubtitle": {}
    };
  }
}
